import Vue from 'vue';

const justifyContent = ['space-between', 'space-evenly', 'start', 'end', 'center'];
const alignItems = ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'];

function createFlex(type: 'Row' | 'Column') {
  return Vue.extend({
    name: type,
    props: {
      center: Boolean,
      justify: {
        type: String,
        default: null,
      },
      alignItems: {
        type: String,
        validator: (align: string) => alignItems.includes(align),
        default: null,
      },
      wrap: {
        type: Boolean,
        default: false,
      },
      alignSelf: {
        type: String,
        validator: (align: string) => alignItems.includes(align),
      },
      flex: {
        type: String,
        default: null,
      },
      reverse: {
        type: Boolean,
        default: false
      }
    },
    inheritAttrs: false,
    render(h) {
      return h(
        'div',
        {
          style: {
            display: 'flex',
            flexDirection: this.reverse ? type.toLowerCase() + '-reverse' : type.toLowerCase(),
            justifyContent: this.justify,
            flexWrap: this.wrap ? 'wrap' : 'initial',
            alignItems: this.center ? 'center' : this.alignItems,
            alignSelf: this.alignSelf,
            flex: this.flex || null,
          },
          attrs: this.$attrs,
        },
        this.$slots.default
      );
    },
  });
}

export const Grid = Vue.extend({
  name: 'Grid',
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    /**
     * The amount of column
     * This props will create a grid-template-columns
     * with formula 100% / column
     */
    column: {
      type: Number,
    },
    templateColumn: {
      type: String,
    },
    /**
     * The amount of row
     * This props will create a grid-template-rows
     * with formula 100% / row
     */
    row: {
      type: Number,
    },
    gap: {
      type: String,
    },
  },
  methods: {
    getTemplates(type: 'column' | 'row'): string {
      return `repeat(${this[type]}, ${100 / this[type]}%)`;
    },
  },
  render(h) {
    return h(
      'div',
      {
        style: {
          display: `${this.inline ? `inline-` : ''}grid`,
          gridTemplateRows: this.row ? `repeat(${this.row}, ${100 / this.row}%)` : 'initial',
          gridTemplateColumns:
            this.templateColumn || (this.column ? `repeat(${this.column}, ${100 / this.column}%)` : 'initial'),
          gridAutoFlows: 'row',
          gap: this.gap,
        },
      },
      this.$slots.default
    );
  },
});

export const Row = createFlex('Row');
export const Column = createFlex('Column');
